(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["harp-homepage"] && !Shopify.designMode) return;
  try {
    
  const showHarpSignupSuccess = () => {
    const successMessage = document.querySelector('[data-harp-discount-success]');
    const signupComplete = document.querySelector('[data-harp-signup-complete]');
    const parameters = new URLSearchParams(window.location.search);
    const signupDiscountWindowName = 'harp-signup-discount-applied';
    const signupDiscountWasApplied = parameters.get('harp_signup') === 'success' || window.name === signupDiscountWindowName;

    if (signupDiscountWasApplied) {
      successMessage?.removeAttribute('hidden');
      parameters.delete('harp_signup');
      const remainingParameters = parameters.toString();
      const cleanUrl = `${window.location.pathname}${remainingParameters ? `?${remainingParameters}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', cleanUrl);

      if (window.name === signupDiscountWindowName) {
        window.name = '';
      }
    }

    if (signupComplete?.dataset.discountUrl) {
      window.name = signupDiscountWindowName;
      window.location.replace(signupComplete.dataset.discountUrl);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showHarpSignupSuccess, { once: true });
  } else {
    showHarpSignupSuccess();
  }

  } catch(e) { console.error(e); }
})();
})();
